import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import {Icon} from '@stubhub/bamboo';

import '../styles/index.scss';

/** Displays the icon related to the payment method. */
const PaymentIcon = ({className, type = 'CreditCard', onClick}) => {
  const handleClick = () => {
    onClick && onClick();
  };

  return (
    <Icon
      className={cx('UIKIT-Payment-Icon', `UIKIT-Payment-Icon--${type}`, className)}
      onClick={handleClick}
      name={type}
    />
  );
};

PaymentIcon.propTypes = {
  /** Optional custom classname */
  className: PropTypes.string,

  /** The type of payment method */
  type: PropTypes.string,

  /** Callback function when the icon is clicked */
  onClick: PropTypes.func,
};

PaymentIcon.displayName = 'PaymentIcon';

export default PaymentIcon;
